module.exports = __webpack_public_path__ + "img/Copy of charles yates, 1958.4d506acc.jpg";